import { Link } from 'react-router-dom';
import './FooterSection.css';
import { BrandLogoLink } from '../BrandLogo';

const COMPANY_LINKS = [
  { label: 'About', href: '/#about' },
  { label: 'Terms & Conditions', href: '/terms-and-conditions' },
  { label: 'Privacy Policy', href: '/privacy-policy' },
  { label: 'Refund Policy', href: '/refund-policy' },
] as const;

export function FooterSection() {
  return (
    <footer className="site-footer">
      <div className="container site-footer__inner">
        <div className="site-footer__brand">
          <BrandLogoLink className="brand-logo--footer" />
        </div>

        <div className="site-footer__grid">
          <nav className="footer-col" aria-labelledby="footer-company">
            <h3 id="footer-company" className="footer-col__title">
              Our Company
            </h3>
            <ul>
              {COMPANY_LINKS.map((link) => (
                <li key={link.label}>
                  {link.href.startsWith('/') ? (
                    <Link to={link.href}>{link.label}</Link>
                  ) : (
                    <a href={link.href}>{link.label}</a>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <hr className="site-footer__divider" />

        <p className="site-footer__copyright">
          Review Lumen 2026. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
